export const getCasePageSelector = state => state.casePage;

export const getIsCurrentUserCreator = state => {
    const currentUserId = state?.currentUser?.id;
    const creatorId = state?.casePage?.caseInfoRequest?.response?.creator_id;

    return currentUserId && creatorId && currentUserId === creatorId;
};
